<template>
  <div >
    <van-row class="list">
       <div class="line_p">
            <p  class="text_333" >主料</p>
             <van-row  class="mgTop20"  >
               <van-col  style="paddingBottom:12px"   v-for="item in info.ingredientDTOS.filter(
            (el) => el.classifyValue == 0
          )"
          :key="item.skuId"  span='12'>
                  <van-col span='12'>{{item.name}}</van-col>
                  <van-col span='12' class="text_ccc">{{item.weight}}</van-col>
               </van-col>
             </van-row>
       </div>
        <div class="mgTop20" >
            <p class="text_333">辅料</p>
             <van-row  class="mgTop20"  >
               <van-col style="paddingBottom:12px"   v-for="item in info.ingredientDTOS.filter(
            (el) => el.classifyValue == 1
          )"
          :key="item.skuId"  span='12'>
                  <van-col span='12'>{{item.name}}</van-col>
                  <van-col span='12' class="text_ccc">{{item.weight}}</van-col>
               </van-col>
             </van-row>
       </div>
    </van-row>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    info: {
      default: {}
    }
  },
  created() {},
  data() {
    return {};
  },

  methods: {}
};
</script>

<style lang='scss' scoped>
.addBtn.van-button--large {
  height: 40px;
  border: 1px dashed rgb(116, 180, 43);
  color: rgb(116, 180, 43);
}
.addBtn.van-hairline--surround::after {
  border: none;
}
 
/deep/ .van-field__control {
  width: 17%;
}
.list {
  margin: 0 0 10px 0;
  background-color: #fff;
  padding:10px 16px
}
/deep/ .van-col{
  font-size: 14px;
}
</style>